import { Form as AntForm } from 'antd'

const useForm = AntForm.useForm
const useWatch = AntForm.useWatch

export { AntForm as Form, useForm, useWatch }
